<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <the-filter :inputs="inputs" customName="الحالة" />
    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <MainLoader key="loader" v-if="loading" />
      <!-- End Main Loader -->

      <div key="main" v-else>
        <!-- Start Statistics Card-->
        <!-- <div class="row mb-5">
          <div class="wrraper">
            <stats-card
              :title="$t('transactionNum')"
              :number="statisticsItem.number"
            ></stats-card>
          </div>
        </div> -->
        <!-- End Statistics Card-->

        <!-- Start Main Section -->
        <main>
          <v-data-table
            class="thumb strip"
            :headers="headers"
            :items="rows"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <!-- Start:: Users Routes -->
            <template v-slot:[`item.driver`]="{ item }">
              <router-link
                v-if="item.driver"
                class="ling_to_user"
                :to="`/driver/edit/${item.driver.id}`"
              >
                <img class="image" :src="item.driver.image" />
                <!-- @error="replaceImage" -->
                <span>
                  {{ item.driver.full_name }}
                </span>
              </router-link>
              <div class="ling_to_user" v-else>لا يوجد</div>
            </template>
            <!-- Start:: Users Routes -->
            <template v-slot:[`item.image`]="{ item }">
              <div v-if="item.image" class="ling_to_user">
                <img class="image" :src="item.image" @click="show_model_1" />
                <!-- @error="replaceImage" -->
              </div>
              <div class="ling_to_user" v-else>لا يوجد تغير</div>
            </template>
            <template v-slot:[`item.full_name`]="{ item }">
              <div v-if="item.full_name">
                {{ item.full_name }}
              </div>
              <div class="ling_to_user" v-else>لا يوجد تغير</div>
            </template>
            <template v-slot:[`item.city`]="{ item }">
              <div v-if="item.city">
                {{ item.city.name }}
              </div>
              <div class="ling_to_user" v-else>لا يوجد تغير</div>
            </template>

            <!-- <template v-slot:[`item.bank_name`]="{ item }">
              <span>
                {{ item.bank_name + " " + item.branch + " " + item.city }}
              </span>
            </template> -->
            <!-- <template v-slot:[`item.status`]="{ item }">
              <span v-if="item.status == 'pending'" class="status pending">
                {{ item.status }}
              </span>

              <span v-if="item.status == 'accepted'" class="status success">
                {{ item.status }}
              </span>
              <span v-if="item.status == 'rejected'" class="status canceled">
                {{ item.status }}
              </span>
            </template> -->
            <template v-slot:[`item.status`]="{ item }">
              <div class="action">
                <div
                  v-if="item.status == 'accepted' || item.status == 'rejected'"
                >
                  <span
                    v-if="item.status == 'rejected'"
                    class="status canceled"
                  >
                    مرفوض
                  </span>
                  <span v-if="item.status == 'accepted'" class="status success">
                    مقبولة
                  </span>
                </div>
                <div
                  class="select-wrapper selecet_shadow mx-auto"
                  style="width: 200px"
                  v-else
                >
                  <div class="input_wrapper">
                    <v-select
                      label="قيد الانتظار"
                      solo
                      :items="orderStatusList(item.status)"
                      @input="changeStatus($event, item.id)"
                    ></v-select>
                  </div>
                </div>
              </div>
            </template>
            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="show" small @click="showItem(item)">
                  fal fa-eye
                </v-icon>
                <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
                <!-- <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon> -->
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <h3 class="title table-title">طلبات تعديل بيانات السائق</h3>
              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    {{ $t("table.deletedialog.areYouSure") }}
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm">
                      {{ $t("table.deletedialog.ok") }}
                    </v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">
                      {{ $t("table.deletedialog.cancel") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Start:: Text Content Modal -->
              <TextContentModal
                @toggleModal="controlReportReasonModalModal"
                :modalIsActive="reportReasonModalIsOpen"
                :title="$t('reportReason')"
                :textContent="reportReasonToShow"
              />
              <!-- End:: Text Content Modal -->
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <template>
          <div
            class="pagination_container text-center mb-5 d-flex justify-content-end"
          >
            <v-pagination
              v-model.number="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="5"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->
      </div>
    </transition-group>
    <!-- Start Image_Model -->
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <!-- End Image_Model -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import TextContentModal from "@/components/Modals/TextContentModal.vue";
import TheFilter from "@/components/Filters/TheFilter.vue";
// End:: Importing Modals

export default {
  name: "UsersReports",

  components: {
    TextContentModal,
    TheFilter,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.update_profile.title"),
          disabled: true,
          href: "",
        },
        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      // ========== Loading
      loading: false,

      // ========== Filter
      inputs: [
        {
          keyName: "user_type",
          user_types: [
            {
              id: "pending",
              name: "قيد الانتظار",
            },
            {
              id: "accepted",
              name: "تم قبول",
            },
            {
              id: "rejected",
              name: "ملغية",
            },
          ],
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "السائق",
            align: "center",
            value: "driver",
            sortable: false,
          },
          // {
          //   text: "الصورة",
          //   align: "center",
          //   value: "image",
          //   sortable: false,
          // },
          // {
          //   text: "الاسم",
          //   align: "center",
          //   value: "full_name",
          //   sortable: false,
          // },
          // {
          //   text: "المدينة",
          //   align: "center",
          //   value: "city",
          //   sortable: false,
          // },

          {
            text: "الحالة",
            align: "center",
            value: "status",
            sortable: false,
          },
          // {
          //   text: "التاريخ",
          //   align: "center",
          //   value: "created_at",
          //   sortable: false,
          // },
          // {
          //   text: "التحكم",
          //   value: "actions",
          //   sortable: false,
          //   align: "center",
          // },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
    orderStatusItems() {
      return [
        {
          label: "في الانتظار",
          name: "pending",
        },
        {
          label: "تمت الموافقة",
          name: "accepted",
        },
        {
          label: "تم الرفض",
          name: "rejected",
        },
      ];
    },
  },

  methods: {
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    changeStatus(currStatus, id) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      submit_data.append("_method", "PUT");
      submit_data.append("status", currStatus);
      this.$axios({
        method: "POST",
        url: `update_profile/${id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("sendSuccess"),
            position: "bottomRight",
          });
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    orderStatusList(status) {
      if (status == "pending") {
        return [
          {
            text: "قبول",
            value: "accepted",
          },
          { text: "رفض", value: "rejected" },
        ];
      }
    },
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },

    // ===== Toggle Report Reason Modal =====
    controlReportReasonModalModal(selectedReportReason) {
      this.reportReasonToShow = selectedReportReason;
      this.reportReasonModalIsOpen = !this.reportReasonModalIsOpen;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/transactions/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/transactions/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/transactions/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `user_reports/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "update_profile",
        params: {
          page: this.paginations.current_page,
          status: this.$route.query.user_type || "pending",
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.statisticsItem.number = res.data.meta.total;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },

  watch: {
    $route: {
      handler() {
        this.setRows();
      },
      immediate: true, // This will make the watcher run when the component is created
    },
  },

  // ======= hooks
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
};
</script>

<style lang="scss" scoped>
.ling_to_user {
  &:hover {
    color: green;
  }
}
</style>
